<template>
  <div>
    <header-sales></header-sales>

    <div id= "subheader"> </div> 

    <div id= "main-container"> 
      <div id= "label-container">
        <span id="label">Carrito de Compras</span>
      </div> 
      <div id= "container">


        <div id= "header-pedido">

          <div id= "header-pedidoL">
              <span class="label-total" v-show='false' >Pedido &nbsp;</span>
              <input id="nPedido-edit" type="text" v-model='numPedido' :class='{inputReadonly: !numPedidoEdit}' :readonly='!numPedidoEdit' v-show='false'/>
              <img id="icon" class="menu" src="/dist/icon-editar.png" v-show='false'/>
          </div>

          <div id= "header-pedidoR">
            <span class="label-subtotal">Subtotal: ${{subtotal | formatMoney}} &nbsp;&nbsp;&nbsp;</span>
            <span class="label-subtotal">Descuentos: ${{descuentos | formatMoney}} &nbsp;&nbsp;&nbsp;</span>
            <span class="label-total">Total: ${{subtotal - descuentos | formatMoney}} </span>
          </div>

        </div>


        <div id="list-container">
          <item-pedido id="list-prod" v-for="item in items" :item='item' @eliminarItem="btnEliminarItem"  ></item-pedido>
        </div>
        <div id="btnContainer">
          <input id="btnEliminar" @click="btnEliminar" type="submit" value="ELIMINAR">
          <input id="btnGuardar" @click="btnGuardar" type="submit" value="GUARDAR">
          <input id="btnAgregar" @click="btnAgregar" type="submit" value="AGREGAR ITEM">
          <input id="btnEnviar" @click="btnEnviar" type="submit" value="ENVIAR">
        </div> 
      </div> 
    </div> 


   <!--popup up-->
   <transition name="fadePro"> 
   <div v-show='showPopup' :showPopup='showPopup'>
     
     <div id='back-popup'>
     </div>
     
     <div id='popup'>

       <div id='popup-btnClose-container'>
        <img id='btnClose' @click="btnCerrarPopup" src="/dist/btnClose.png" style="width: 20px;height: 20px">
       </div>

       <p id='popup-titulo'>Enviar Pedido</p>
       <div id="comboContainer">
         <select  v-model="sucursal">
           <option value="" disabled>Seleccione Dirección</option>
           <option v-for="option in sucursales" v-bind:value="option">{{ option.Direccion }}</option>
         </select>
         <textarea id='obs' placeholder="Ingrese observación" v-model="observaciones"> </textarea>
       </div> 
   
       
       <div id="btnContainerPopup">
         <input class="botonPopup" @click="btnCerrarPopup" id="btnCerrarPopup" type="submit" value="CANCELAR">
         <input class="botonPopup" @click="btnEnviarPopup" id="btnEnviarPopup" type="submit" value="ENVIAR">
       </div> 

     </div> 
    
   </div> 
  </transition>


  </div>
</template>


<script>
  import axios from 'axios'
  import HeaderSales from '@components/views/header.vue';
  import ItemPedido from '@components/views/pedido/ItemPedido.vue';
  import Vue from 'vue'

  export default {
    name: 'Pedido',
    components:{
     'header-sales': HeaderSales,
     'item-pedido': ItemPedido,
    },


    data() {
       return {
         showPopup:false,
         productos:[],
         pedido:null,
         pedidos: [],
         observaciones:'',
         grupoProductos:  [],
         descuentosAplicados: [],
         descuentosPedido: [],           //--> AGREGAR   
         descuentosSend: [],
         sucursal: "",
         numPedidoEdit:false,
         idItemEliminar:-1
       }
    },


    computed: {

      numPedido(){
        if ((this.$store.state.pedido.pedidosHome != null) && (this.$store.state.pedido.pedidosHome.length > 0))
        {
          return this.$store.state.pedido.pedidosHome[0].Id
        }
        else
        {
          return 0
        }
      },

      items () {
        var des = [];
        this.descuentosAplicados.forEach((e)=> { 
          var de = { archivoId:192,
                      cantidad:1,
                      descripcion:e.Nombre,
                      id:0,
                      idCategoria:0,
                      idSubcategoria:0,
                      peso:0,
                      precio:e.importe,
                      producto:e.Nombre,
                      tipoOblea:2
                    }
          des.push(de); 
        });

        var car = this.$store.state.pedido.carrito;
      
        return car.concat(des);    
      }, 

      subtotal () {
        var st= 0.0; 
        this.$store.state.pedido.carrito.forEach(function(element) {
          st = st + element.precio * element.cantidad;
        });     
        return st;
      },

      descuentos () {
        this.grupoProductos= []
        this.descuentosAplicados=[]
        this.$store.state.pedido.carrito.forEach((element)=> {
          var index= this.grupoProductos.findIndex(e => (e.idCategoria == element.idCategoria  &&  e.idSubcategoria == element.idSubcategoria ));  
          if (index == -1)
          {
             var ngp = {
              idCategoria: element.idCategoria,
              idSubcategoria: element.idSubcategoria,
              importeTotal: element.precio * element.cantidad,
              cantUnidTotal: element.cantidad,     
              pesoTotal: element.peso * element.cantidad     
            }
            this.grupoProductos.push(ngp)
          }
          else
          {
            this.grupoProductos[index].importeTotal = this.grupoProductos[index].importeTotal + (element.precio * element.cantidad);
            this.grupoProductos[index].cantUnidTotal = this.grupoProductos[index].cantUnidTotal + element.cantidad;
            this.grupoProductos[index].pesoTotal = this.grupoProductos[index].pesoTotal + (element.peso * element.cantidad);
            console.log('>>'+this.grupoProductos[index].pesoTotal)  


          }
        });     

        this.grupoProductos.forEach((gp)=> { 
          var desc = this.$store.state.pedido.descuentos.find(d => (d.CategoriaId == gp.idCategoria  &&  d.SubcategoriaId == gp.idSubcategoria ));  

          //test

            // desc.Tipo = 2               //unidades 
            // desc.LimiteInferior = 3     // 3 unidades
            // desc.LimiteSuperior = 300   // $300

            // desc.Tipo = 1               // monto 
            // desc.LimiteInferior = 100   // $100
            // desc.LimiteSuperior = 300   // $300

            // desc.Tipo = 3               //peso 
            // desc.LimiteInferior = 10    // 10 Kg
            // desc.LimiteSuperior = 300   // $300

          //test


          if (desc != null)
          {

            if (desc.Tipo == 1) // descuento por importe total
            { 

               if (gp.importeTotal >= desc.LimiteInferior)
               {
                 var porc    =  desc.PorcentajeDescuento/100; 
                 var impDesc =  gp.importeTotal * porc;
                 if (desc.LimiteSuperior != 0)
                 {
                   if (impDesc >= desc.LimiteSuperior)
                   {
                    impDesc = desc.LimiteSuperior;
                   } 
                 } 

                 this.descuentosAplicados.push({DescuentoId:desc.Id,
                                                Porcentaje:desc.PorcentajeDescuento,
                                                Tipo:desc.Tipo,
                                                CategoriaId:desc.CategoriaId,
                                                SubcategoriaId:desc.SubcategoriaId,
                                                Nombre:desc.Nombre,
                                                Observacion:desc.Observacion,
                                                importe:impDesc
                 });
               }
            }


            if (desc.Tipo == 2) // descuento por cant unidades total
            { 
               if (gp.cantUnidTotal >= desc.LimiteInferior)
               {
                 var porc    =  desc.PorcentajeDescuento/100; 
                 var impDesc =  gp.importeTotal * porc;
                 if (desc.LimiteSuperior != 0)
                 {
                   if (impDesc >= desc.LimiteSuperior)
                   {
                    impDesc = desc.LimiteSuperior;
                   } 
                 } 

                 this.descuentosAplicados.push({DescuentoId:desc.Id,
                                                Porcentaje:desc.PorcentajeDescuento,
                                                Tipo:desc.Tipo,
                                                CategoriaId:desc.CategoriaId,
                                                SubcategoriaId:desc.SubcategoriaId,
                                                Nombre:desc.Nombre,
                                                Observacion:desc.Observacion,
                                                importe:impDesc
                 });
               }
            }


            if (desc.Tipo == 3) // descuento por peso total
            { 
               console.log('>>>>'+gp.pesoTotal)
               if (gp.pesoTotal >= desc.LimiteInferior)
               {
                 var porc    =  desc.PorcentajeDescuento/100; 
                 var impDesc =  gp.importeTotal * porc;
                 if (desc.LimiteSuperior != 0)
                 {
                   if (impDesc >= desc.LimiteSuperior)
                   {
                    impDesc = desc.LimiteSuperior;
                   } 
                 } 

                 this.descuentosAplicados.push({DescuentoId:desc.Id,
                                                Porcentaje:desc.PorcentajeDescuento,
                                                Tipo:desc.Tipo,
                                                CategoriaId:desc.CategoriaId,
                                                SubcategoriaId:desc.SubcategoriaId,
                                                Nombre:desc.Nombre,
                                                Observacion:desc.Observacion,
                                                importe:impDesc
                 });
               }

            }
          }
        });

        var descTotal = 0;
        this.descuentosAplicados.forEach((e)=> { 
          console.log(e.Nombre+' - '+e.importe); 
          descTotal = descTotal + e.importe;
        });

        return descTotal; 
      },

      sucursales () {
         return this.$store.state.user.sucursales;

      },

    },


  methods: {


    btnEdit() {
      if (this.numPedidoEdit)
      {
        this.numPedidoEdit = false
      }
      else
      {
        this.numPedidoEdit = true
      }
    },

    validar() {
      var rex = new RegExp(/^\d+$/);
      var ok = true;
      this.$store.state.pedido.carrito.forEach((e)=> {
        if (!rex.test(e.cantidad))  
        {
          ok = false;
        }
        else
        {
          if (e.cantidad < 1)
          {
            ok = false;
          }
        }  
      });
      return ok;
    },


    btnEliminarItem(id) {
      this.idItemEliminar = id
      var obj = {
                 txt:'¿Desea eliminar el item del pedido?',
                 txtBtnCancel:'Cancelar',
                 txtBtnOk:'Aceptar',
                 fCancel:null,
                 fOk:this.eliminarItem
                }
      this.$store.commit('popup/open',obj);
     },


    eliminarItem() {
      this.$store.commit('pedido/eliminarItemPedido',this.idItemEliminar)   
      this.$router.push({ name: 'reload' });
    },



    btnEliminar() {
      var obj = {
                 txt:'¿Desea eliminar el pedido?',
                 txtBtnCancel:'Cancelar',
                 txtBtnOk:'Aceptar',
                 fCancel:null,
                 fOk:this.eliminarPedido
                }
      this.$store.commit('popup/open',obj);
    },


    eliminarPedido() {
      this.$store.commit('pedido/eliminarPedido')
      this.$router.push({ name: 'home' });
    },




     btnAgregar() {
       this.$router.push({ name: 'realizarPedido' });
     },


     btnCerrarPopup() {
       this.showPopup = false; 
     },


     btnEnviar() {
       if (this.validar())
       {
         this.descuentosSend=[];
         this.descuentosAplicados.forEach((e)=> { 
           var ds = { DescuentoId: e.DescuentoId,
                     DescuentoPorcentaje:e. Porcentaje,
                     DescuentoImporte:e.importe
                   }
           this.descuentosSend.push(ds)
         });
         this.showPopup = true; 
       }
       else
       {
         var obj = {
                     txt:'Todos los campos cantidad deben contener valores numéricos enteros mayores a 0',
                     txtBtnCancel:'',
                     txtBtnOk:'Aceptar',
                     fCancel:null,
                     fOk:null
                   }
         this.$store.commit('popup/open',obj);
       }
     },


  getFechaEntrega() {
      var date    = new Date();
      var dayInMillis = 86400000
      var daysOffset  = 0
      var diasHabiles = 0
      var currentMillis = date.getTime()

      date.setTime(currentMillis+(daysOffset*dayInMillis)) 

      while ((date.getDay() == 0) || (date.getDay() == 6))
      {
        daysOffset++
        date.setTime(currentMillis+(daysOffset*dayInMillis)) 
      }

      while (diasHabiles<2)
      {
        daysOffset++
        date.setTime(currentMillis+(daysOffset*dayInMillis)) 
        if ((date.getDay() != 0) && (date.getDay() != 6))
        {
          diasHabiles++
        }
      }
      date.setTime(currentMillis+(daysOffset*dayInMillis)) 

      var fecha = date.toLocaleString("en-GB")
      var arrayFecha = fecha.split(",")

      return arrayFecha[0]
    },



     // ----------------------- ENVIAR PEDIDO --------------------------

     btnEnviarPopup() {
       if (this.sucursal.Direccion != null) 
       {
         this.$store.commit('loader/start')
         this.descuentosPedido = [];                          // --> AGREGAR 
         this.$store.state.pedido.carrito.forEach((item => {

          /*******************************test****************************************/ // --> AGREGAR BLOQUE TEST 
          var descProd = [];                                  
          this.$store.state.pedido.descuentos.forEach((itemDesc => {

            if ((itemDesc.CategoriaId == item.idCategoria) && (itemDesc.SubcategoriaId == item.idSubcategoria))
            {
              var dp = null
              dp = {'DescuentoId':itemDesc.Id,
                    'DescuentoPorcentaje': itemDesc.PorcentajeDescuento,
                    'DescuentoImporte': (((item.precio*itemDesc.PorcentajeDescuento)/100) * item.cantidad)
                   } 
              descProd.push(dp)
              this.descuentosPedido.push(dp)
            } 
          }))
          /*******************************test*****************************************/

          var producto = {'ProductoId':item.id,
                          'PromocionId':item.promocionId,
                          'Largo':0,
                          'Ancho':0,
                          'Cantidad':item.cantidad,
                          'Precio':item.precio,
                          'PrecioLista':item.precio,
                          'Descuentos':descProd              // --> AGREGAR 
                         } 

          this.productos.push(producto)  
        }));



        this.pedido = {
          'Id': 1,
          'BorradorId': 0,
          'Fecha': this.getFechaActual(),      
          'FechaEntrega': this.getFechaEntrega(),
          'FechaTarea': "01/01/2000",
          'ClienteId': this.$store.state.user.clienteId,
          'ClienteSucursalLinea': this.sucursal.Linea, 
          'ListaPrecioId':  this.$store.state.user.listaDePrecio,
          'CondicionVentaId': 0,
          'Observaciones': this.observaciones,
          'CodigoHash': Math.floor(Math.random() * 1000000000),
          'Latitud': 0,
          'Longitud': 0,
          'GpsEncendido': false,
          'Productos': this.productos,
           // 'Descuentos': this.descuentosSend       
          'Descuentos': this.descuentosPedido                 // --->  AGREGAR  
          } 


        console.log(this.pedido)
        this.pedidos.push(this.pedido); 
        console.log(this.pedidos)

        axios.post('/WebSalesPedido', {"Pedidos":this.pedidos} ,{
          headers:{
                   Token:this.$store.state.user.token,
                   ClientSecret: process.env.CLIENT_SECRET,
                   EmpresaId: process.env.EMPRESA_ID
                  }
          }
        )
          .then((response) => {
            this.showPopup = false;
            this.$store.commit('loader/stop')
            if (response.data.Code == 0)
            {
              console.log(response.data)

              if (response.data.Pedidos[0].Procesado)
              {
                if (this.$store.state.pedido.borradorId != 0)
                {
                    this.eliminarBorrador(this.$store.state.pedido.borradorId)
                }
                else
                {
                    this.$store.commit('pedido/eliminarPedido');
                    this.$router.push({name: 'estadoPedido'});
                }
              }
              else
              {
                  var obj = 
                  {
                    txt: response.data.Pedidos[0].Mensaje,
                    txtBtnCancel: "",
                    txtBtnOk: "Aceptar",
                    fCancel: null,
                    fOk: null
                  };
                  this.$store.commit("popup/open", obj);
              }
            }
            else if (response.data.Code == 99)
            {
              alert(response.data.Message) 
              this.$router.push({name: 'login'});
            }
            else
            {
              console.log(">>>>"+response.data.Message);
              alert(response.data.Message);  
            }
          })
          .catch((error) => {
            console.log(error);
          });

        } 
        else
        {
           var obj = {
                      txt:'Debe completar dirección',
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                     }
           this.$store.commit('popup/open',obj);
        }
     },



     // ----------------------- GUARDAR PEDIDO --------------------------
     btnGuardar() {
       this.$store.commit('loader/start')
       this.descuentosPedido = [];                          // --> AGREGAR 
       this.$store.state.pedido.carrito.forEach((item => {

        /*******************************test****************************************/ // --> AGREGAR BLOQUE TEST 
        var descProd = [];                                  
        this.$store.state.pedido.descuentos.forEach((itemDesc => {

          if ((itemDesc.CategoriaId == item.idCategoria) && (itemDesc.SubcategoriaId == item.idSubcategoria))
          {
            var dp = null
            dp = {'DescuentoId':itemDesc.Id,
                  'DescuentoPorcentaje': itemDesc.PorcentajeDescuento,
                  'DescuentoImporte': (((item.precio*itemDesc.PorcentajeDescuento)/100) * item.cantidad)
                 } 
            descProd.push(dp)
            this.descuentosPedido.push(dp)
          } 
        }))
        /*******************************test*****************************************/

       var producto = {'ProductoId':item.id,
                       'PromocionId':item.promocionId,
                       'Largo':0,
                       'Ancho':0,
                       'Cantidad':item.cantidad,
                       'Precio':item.precio,
                       'PrecioLista':item.precio,
                       'Descuentos':descProd                           // --> AGREGAR 
                      }

        this.productos.push(producto)  
       }));

       this.pedido = {
         'Id': 1,
         'BorradorId': this.$store.state.pedido.borradorId,
         'Fecha': this.getFechaActual(),
         'FechaEntrega': this.getFechaEntrega(),
         'FechaTarea': "01/01/2000",
         'ClienteId': this.$store.state.user.clienteId,
         'ClienteSucursalLinea': 0, 
         'ListaPrecioId':  this.$store.state.user.listaDePrecio,     
         'CondicionVentaId': 0,
         'Observaciones': this.observaciones,
         'CodigoHash': Math.floor(Math.random() * 1000000000),
         'Latitud': 0,
         'Longitud': 0,
         'GpsEncendido': false,
         'Productos': this.productos,
         //'Descuentos':  []
         'Descuentos': this.descuentosPedido                 // --->  AGREGAR  
        } 
       axios.post('/WebSalesBorrador', this.pedido ,{
         headers:{
                   Token:this.$store.state.user.token,
                   ClientSecret: process.env.CLIENT_SECRET,
                   EmpresaId: process.env.EMPRESA_ID
                 }
         }
       )
        .then((response) => {
          this.$store.commit('loader/stop')
          if (response.data.Code == 0)
          {
            this.$store.commit('pedido/eliminarPedido');
            this.$router.push({name: 'estadoPedido'});
          }
          else if (response.data.Code == 99)
          {
            alert(response.data.Message) 
            this.$router.push({name: 'login'});
          }
          else
          {
            console.log(">>>>"+response.data.Message);
            alert(response.data.Message);  
          }
        })
        .catch((error) => {
          alert("error") 
          console.log(error);
        });
     },




    eliminarBorrador (borradorId) {
      this.$store.commit('loader/start')
      var bdParam = { BorradorId:borradorId,
                      ClienteId:this.$store.state.user.clienteId,	
                      EmpleadoId:0
                    }
  
      axios.put('/WebSalesBorrador',bdParam,{
      headers:{
                Token:this.$store.state.user.token,
                ClientSecret: process.env.CLIENT_SECRET,
                EmpresaId: process.env.EMPRESA_ID
              }
      }
      ).then((response) => {
        this.$store.commit('loader/stop')
        this.$store.commit('pedido/eliminarPedido');
        if (response.data.Code == 0)
         {
           this.$router.push({name: 'estadoPedido'});
         }
         else if (response.data.Code == 99)
         {
           alert(response.data.Message);
         }
         else
         {
           console.log(">>>>"+response.data.Message);
         }
      },(error) => { console.log(error) 
            alert(error);  })
    
    },



     getFechaActual(){
      
       //'Fecha': "dd/mm/yyyy hh:mm",      
        var date    = new Date();
        var dateUTC = new Date();    
        var dia     =  ''
        var mes     =  ''
        var hora    =  ''
        var minuto  =  ''

        dateUTC.setTime(date.getTime() + 10800000) 

        if (dateUTC.getDate()<10)
        {
          dia = '0'+ dateUTC.getDate().toString()
        }
        else
        {
          dia = dateUTC.getDate().toString()
        }

        if ((dateUTC.getMonth() + 1)<10)
        {
          mes = '0'+ (dateUTC.getMonth()+1).toString()
        }
        else
        {
          mes = (dateUTC.getMonth()+1).toString()
        }

        if (dateUTC.getHours()<10)
        {
          hora = '0'+ dateUTC.getHours().toString()
        }
        else
        {
          hora = dateUTC.getHours().toString()
        }

        if (dateUTC.getMinutes()<10)
        {
          minuto = '0'+ dateUTC.getMinutes().toString()
        }
        else
        {
          minuto = dateUTC.getMinutes().toString()
        }

        console.log(dia+'/'+mes+'/'+dateUTC.getFullYear()+' '+hora+':'+minuto)

        return  dia+'/'+mes+'/'+dateUTC.getFullYear()+' '+hora+':'+minuto;
     },

   },

   mounted () {
    this.$store.commit('loader/stop')
   }

 }

</script>

<style scoped>


#back-popup{
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100vh;
background: #000000;
opacity: 0.6;
filter: alpha(opacity=60); 
}


#popup{
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);
width: 400px;
height: 340px;
border-radius: 15px;
box-sizing: border-box;
background: #ffffff;
border-style: solid;
border-width: 1px;
border: 1px solid #dddddd;
}


#popup-btnClose-container{
  display: flex;            
  flex-direction:row;  
  margin-top: 10px;
  height: 20px;
  padding-right: 10px;
  align-items: center;  
  justify-content: flex-end; 
  background:  #ffffff
}


#popup-titulo{
 font-size: 26px;
 /*font-weight: bold;*/
 color: #5C666F;
 text-align: center;
}


#obs
{
  resize: none;
  width: 330px;
  margin-top: 20px;
  padding: 10px;
  border-radius: 5px;  
  margin-bottom: 10px;
  height:90px;
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #dddddd;
  font-family: 'Rubik', sans-serif;
}



select{
  width: 350px;
  height:30px;
  padding-left: 5px;
  border-radius: 5px;  
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #dddddd;
  font-family: 'Rubik', sans-serif;
}


select :disabled {
  color:#dddddd;
}




#comboContainer{
  margin-top: 20px;
  display: flex;            
  flex-direction: column;
  justify-content: center;  
  align-items: center;  
}



#btnContainerPopup{
  height: 80px;
  display: flex;            
  flex-direction: row;  
  justify-content: center;  
  align-items: center;  
}


.botonPopup{
 height: 40px;
 font-size: 10px;
 font-weight: bold;
 margin-left: 10px;
 margin-right: 10px;
 border-radius: 20px;  
 border-style: solid;
 border:none; 
}


#btnCerrarPopup{
  width: 100px;
  color: #4969B2;
  background: #ffffff; 
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
}

#btnEnviarPopup{
  width: 100px;
  background: #44C7F4; 
  color: #ffffff;
  outline: none;
}



.boton:hover { cursor: pointer; }
#btnClose:hover { cursor: pointer; }



.fadePro-enter {
  opacity: 0;
}
.fadePro-enter-active {
  transition: opacity 0.5s;
}
.fadePro-enter-to {
  opacity: 1;
}
.fadePro-leave {
  opacity: 1;
}
.fadePro-leave-active {
  transition: opacity 0.1s;
}
.fadePro-leave-to {
  opacity: 0;
}



/*----------------------------*/

 #subheader {
  width: 100%;
  height: 35vh;
  background: linear-gradient(#005A9F , #1899D6);
 }

 #main-container{
  position: absolute;
  top: 55vh;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 700px;
  height: 85vh;
 }

 #label-container{
  width: 700px;
  height: 10vh;
 }

  #label{
  color:#ffffff;
  font-size: 27px;
 }

  #container{
   width: 700px;
   height: 75vh;
   border-width: 1px;
   border: 1px solid #dddddd;
   box-sizing: border-box;
   box-shadow: 3px 3px 4px #dddddd;
   background-color: #ffffff;
   display: flex;
   flex-direction:column; 
   align-items: center; 
  }


#header-pedido{
 width: 700px;
 height: 50px; 
 display: flex;      
 flex-direction: row;  
 justify-content: center; 
 align-items: center; 
}

#header-pedidoL{
 width: 230px;
 height: 100%; 
 display: flex;      
 flex-direction: row;  
 background: #ffffff;
 justify-content: flex-start;
 align-items: center;    
}

#header-pedidoR{
 width: 400px;
 height: 100%; 
 display: flex;      
 flex-direction: row;  
 background: #ffffff;
 justify-content: flex-end;  
 align-items: center;    
}


.nPedido{
 font-size: 18px;
 font-weight: bold;
 color:#5D6770;
}


 input{
 width: 80px; 
 font-size: 18px;
 text-align: center;
 color:#5D6770;
 border-radius: 5px;  
 height:20px;
 border:none; 
 border-style: solid;
 border-width: 1px;
 border: 1px solid #dddddd;
} 

.inputReadonly{
 width: 80px; 
 border:none; 
} 



#label-editar{
 font-size: 12px;
 color:#5D6770;
}


#total-container{
  width: 660px;
  height: 7vh;
  display: flex;
  flex-direction:row; 
  justify-content: flex-end; 
  align-items: center; 
}



#list-container{
  width: 660px;
  height: 60vh;
  padding-top: 30px;
  background: #ffffff;
  overflow: auto;
  display: flex;
  flex-direction:column; 
  align-items: center; 
 }


#btnContainer{
  width: 660px;
  height: 7vh;
  display: flex;
  flex-direction:row; 
  justify-content: flex-end; 
  align-items: center; 
}


.label-total{
 font-size: 16px;
 color:#5D6770;
}

.label-subtotal{
 font-size: 12px;
 color:#5D6770;
}
 



#btnEliminar{
  width: 100px;
  height: 30px;
  font-size: 9px;
  margin-left: 5px;
  margin-right: 5px;
  border-style: solid;
  border:none; 
  color: #4969B2;
  background: #ffffff; 
  border-radius: 20px;  
  border-width: 1px;
  border: 1px solid #ffffff;
  outline: none;
}


#btnGuardar{
  width: 100px;
  height: 30px;
  font-size: 9px;
  margin-left: 5px;
  margin-right: 5px;
  border-style: solid;
  border:none; 
  color: #4969B2;
  background: #ffffff; 
  border-radius: 20px;  
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
}


#btnAgregar{
  width: 120px;
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 9px;
  border-style: solid;
  border:none; 
  background: #44C7F4; 
  border-radius: 20px;  
  color: #ffffff;
  outline: none;
}

#btnEnviar{
  width: 80px;
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 9px;
  border-style: solid;
  border:none; 
  background: #44C7F4; 
  border-radius: 20px;  
  color: #ffffff;
  outline: none;
}


input[type="submit"]:hover
{
  cursor: pointer;
}

#icon:hover
{
  cursor: pointer;
}



 /* width */
  ::-webkit-scrollbar {
      width: 5px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #dddddd; 
      border-radius: 10px;
  }
  
   
  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #bbbbbb; 
      border-radius: 10px;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #cccccc; 
  }
  
  
  ::-webkit-scrollbar { 
  display: block; }
 


</style>


// WEBPACK FOOTER //
// src/components/views/pedido/pedido.vue